export const tr = {
    'button-cancel': 'İptal'
};
